// extracted by mini-css-extract-plugin
module.exports = {"root":"root___2QJ37","iconWrapper":"iconWrapper___1cxPR","title":"title___1JQ2n","text":"text___jcKhX","loading":"loading___3zt_A"};